import React from 'react';
import { Package, FilePlus2, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BottledWinesToolbar = ({ onAdd, search, onSearchChange }) => {
    const navigate = useNavigate();

    return (
        <div className="sticky-top bg-light border-bottom">
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <Package size={24} />
                        <h5 className="mb-0 me-3">Bottled Wines</h5>
                        <div className="input-group">
                            <span className="input-group-text">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Bottled Wines..."
                                value={search}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                        </div>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center"
                                onClick={() => navigate('/inventory')} // Use navigate for navigation
                            >
                                <Package size={18} className="me-2" />
                                Inventory
                            </button>
                            <button 
                                className="btn btn-outline-primary"
                                onClick={onAdd}
                                title="Add New Bottled Wine"
                            >
                                <FilePlus2 size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default BottledWinesToolbar;